module.exports = __webpack_public_path__ + "img/14-white.d13fe01d.svg";